'use strict';

export default function routes($stateProvider) {
    'ngInject';

    $stateProvider.state('oem_main.company_edit', {
        url: '/company_edit/:company_id',
        template: '<company-edit></company-edit>'
    });
}



// WEBPACK FOOTER //
// ./public/dev/app/company/edit/company_edit.route.js